 import React from 'react';

const NotificationEdit: React.FC = () => {
  return <div>Edit Notification</div>;
};

export default NotificationEdit;
